import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "card text-center" }
const _hoisted_3 = { class: "card-body py-5" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "text-success"
}
const _hoisted_6 = {
  key: 2,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "spinner-border text-primary mb-3" }, null, -1),
              _createElementVNode("h5", null, "Vérification du paiement...", -1)
            ]))]))
          : (_ctx.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-check-circle fa-4x mb-3" }, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Rechargement réussi !", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", null, "Votre compte a été crédité avec succès.", -1)),
                _createVNode(_component_router_link, {
                  to: "/listePrepaidAccount",
                  class: "btn btn-primary mt-3"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Voir mon compte ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-times-circle fa-4x mb-3" }, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Échec du rechargement", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1),
                _createVNode(_component_router_link, {
                  to: "/listePrepaidAccount",
                  class: "btn btn-secondary mt-3"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Retour ", -1)
                  ]))]),
                  _: 1
                })
              ]))
      ])
    ])
  ]))
}